module.exports = __webpack_public_path__ + "img/MTCIFIMB.c305ac6c.png";